export default __webpack_public_path__ + "static/media/player_play.fc6a328d.svg";